






























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { NotificationEventBus } from '@/EventBus';
import { Auth, Logger } from 'aws-amplify';
import EditableField from '@/components/common/EditableField.vue';
import ImagePicker from '@/components/common/ImagePicker.vue';
import Users from '@/store/modules/Users';
import { Urls } from '@/Urls';
import ChangePasswordDialog from '@/views/Auth/ChangePasswordDialog.vue';

const users = getModule(Users);
// Logger.LOG_LEVEL = "DEBUG";
const logger = new Logger('Account.vue');

@Component({
    components: {
        EditableField,
        ImagePicker,
        ChangePasswordDialog,
    },
})
export default class Account extends Vue {
    private readonly Urls = Urls;
    private user: any = {
        first: '',
        last: '',
        phone: '',
        email: '',
        image: '',
    };
    private componentKey: number = 0;
    private verifyDialog = false;
    private verifyAttribute = '';
    private verifyCode = '';
    private verifyLoading = false;

    mounted() {
        // Auth.currentAuthenticatedUser({bypassCache: true}).then(r => console.log(r));
        this.user = Object.assign(this.user, this.userProfile);
    }

    get authUser() {
        return users.currentAuthUser;
    }

    get userProfile() {
        return users.currentUserProfile;
    }

    @Watch('userProfile')
    userProfileChanged() {
        this.user = Object.assign(this.user, this.userProfile);
    }
// TODO: DRUPAL TEMP CHANGE
    private signOut() {
        this.user = {};
        Auth.signOut();
    }

    private async fieldChanged() {
        users
            .updateUserProfile(this.user)
            .then(() => {
                logger.debug('fieldChanged() >>> users.updateUserProfile(this.user)', this.user);
                NotificationEventBus.emitSuccessMessage();
            })
            .catch((err) => {
                logger.error('fieldChanged() >>> users.updateUserProfile(this.user)', err);
                NotificationEventBus.emitFailedMessage(err);
            });
    }

    // need to force a re-render due to v-mask in EditableField.vue not re-rendering correctly
    // TODO - Find better method of forcing a re-render of the phone # input on @cancel (2020-05-28)
    private reRender() {
        this.componentKey++;
    }

    private async verifyStart(attributeName: string) {
        this.verifyLoading = true;
        await Auth.verifyCurrentUserAttribute(attributeName);
        this.verifyAttribute = attributeName;
        this.verifyLoading = false;
        this.verifyDialog = true;
    }

    private async verifySubmit() {
        this.verifyLoading = true;
        await Auth.verifyCurrentUserAttributeSubmit(this.verifyAttribute, this.verifyCode);
        await users.getCurrentAuthUser(true);
        this.verifyLoading = false;
    }
}
